import { styled } from '@mui/material/styles';

import { typography } from '../KestrixDesignSystem.jsx';

/** Helper message wrapper (icon + text) below a form field. */
export const HelperMessageRow = styled('span')({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  marginTop: 4,
  fontSize: typography.body.small.fontSize,
  lineHeight: typography.body.small.lineHeight,
  fontWeight: typography.body.small.fontWeight,
  fontFamily: typography.fontFamily.primary,
  whiteSpace: 'nowrap',
});
